/**
 * Gesundheitsportal - Online Appointments REST API
 * Gesundheitsportal Online Appointments Service REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: valeriu.craciun@kronsoft.ro
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Waiting List Booking Status Enum
 */
export type WaitingListStatusFilterEnumDTO = 'BOOKED' | 'DENIED' | 'UNDEFINED';

export const WaitingListStatusFilterEnumDTO = {
    BOOKED: 'BOOKED' as WaitingListStatusFilterEnumDTO,
    DENIED: 'DENIED' as WaitingListStatusFilterEnumDTO,
    UNDEFINED: 'UNDEFINED' as WaitingListStatusFilterEnumDTO
};

